var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"className":"arrow-slider-circle","cx":"12","cy":"12","r":"11.5","fill":"none","stroke":"#8C8C8C","key":0}),React.createElement("path",{"className":"arrow-slider-shape","fill":"#8C8C8C","d":"M10.5088835 12l3.3080582-3.02451041c.2440777-.22315674.2440777-.5849653 0-.80812204-.2440776-.22315673-.6398058-.22315673-.8838834 0L9.18305826 11.595939c-.24407768.2231567-.24407768.5849653 0 .808122l3.75000004 3.4285714c.2440776.2231568.6398058.2231568.8838834 0 .2440777-.2231567.2440777-.5849653 0-.808122L10.5088835 12z","key":1})]);
}

ChevronLeft.defaultProps = {"viewBox":"0 0 24 24","style":{"position":"absolute","height":"100%","width":"100%","left":"0","top":"0"}};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
